import { Select } from 'antd';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {}

function LangSwitch(props: Props): ReactElement {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Select
      defaultValue={i18n.language}
      onChange={changeLanguage}
      bordered={false}
    >
      <Select.Option value="lt">LT</Select.Option>
      <Select.Option value="en-US">EN</Select.Option>
    </Select>
  );
}

export default LangSwitch;
